import { connect } from 'react-redux';
import { RootState } from '../../store/reducers';
import MainComponent from './MainComponent';

const mapStateToProps = (state: RootState) => {
    const { appReducer, navReducer } = state;
    const loading = appReducer.loading;
    const activeId = navReducer.navId;

    return {
        loading,
        activeId
    };
};

const mapDispatchToProps = () => {
    return {};
};

const MainContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(MainComponent);

export default MainContainer;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/MainContainer.tsx